import { boolean, date, number, object, string } from "yup";

export const programacionValidationSchema = object({
  id_cultivo: number().moreThan(0).required(),
  id_variedad: number().when("color", (color, schema) =>
    color === 0 ? schema.moreThan(0).required() : schema
  ),
  calibre: string().required(),
  id_tipo_etiqueta: number().moreThan(0).required(),
  id_peso_envase: number().moreThan(0).required(),
  id_tipo_caja: number().moreThan(0).required(),
  id_etiqueta: number().moreThan(0).required(),
  id_bultos: number(),
  bultos: number().moreThan(0).required(),
  cantidad: number().moreThan(0).required(),
  id_yeguere: number().moreThan(0).required(),
  id_destino: number().moreThan(0).required(),
  tipo: string().required(),
  id_destino_inmediato: number().moreThan(0).required(),
  id_tarima: number().moreThan(0).required(),
  fumigar: boolean().required(),
  prioridad: boolean().required(),
  observaciones: string(),
  fecha: date().required(),
  color: number(),
});

export const programacionFilterValidationSchema = object({
  id_cultivo: number().moreThan(0).required(),
  fecha: date().required(),
});
